import { wrapReducers } from 'redaction'
import localReducers from 'redux/reducers'
import wrapRouterReducers from 'redux/models/router/reducer'


export default (dispatchResolver) => ({
  misc: wrapReducers(localReducers.misc, 'misc'),
  view: wrapReducers(localReducers.view, 'view'),
  models: wrapReducers(localReducers.models, 'models'),
  router: wrapRouterReducers(dispatchResolver),
})
